<template>
  <div>
    <Logo :parentData="pageData" />
    <BackStageMenu :parentData="pageData" />
    <div id="contents" class="clearfix" style="min-height: 470px">
      <div id="main_area">
        <div class="information">
          <h3>S315 帳號資料維護</h3>
          <div class="table_scroll2">
            <table class="newTable">
              <tbody>
                <tr>
                  <td>身分證統一編號：</td>
                  <td>
                    <input type="text" maxlength="10" v-model="form.idn" />
                  </td>
                </tr>
                <tr>
                  <td>帳號：</td>
                  <td>
                    <input type="text" maxlength="10" v-model="form.id" />
                  </td>
                </tr>
                <tr>
                  <td>姓名：</td>
                  <td>
                    <input type="text" maxlength="10" v-model="form.name" />
                  </td>
                </tr>
                <tr>
                  <td colspan="6" class="f_center">
                    <input
                      type="submit"
                      class="btn"
                      value="查詢"
                      @click="doQuery()"
                    />
                    <input
                      type="submit"
                      class="btn"
                      value="新增"
                      @click="btnAdd()"
                    />
                    <input
                      type="submit"
                      class="btn"
                      value="重填"
                      @click="doClear()"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- 查詢結果開始-->
        <div class="information">
          <table width="100%">
            <tbody>
              <tr>
                <td></td>
                <td v-if="grid.paginaiton" align="right">
                  <input
                    type="button"
                    value="<<"
                    class="btn"
                    style="height: 28px"
                    @click="form.currentpage = grid.paginaiton.pageNo - 1"
                    v-show="grid.paginaiton.pageNo > 1"
                  />
                  <span
                    v-for="(data, index) in grid.paginaiton.pages"
                    :key="index"
                    style="cursor: pointer"
                    :style="
                      grid.paginaiton.pageNo == data
                        ? 'color:red'
                        : 'color:black'
                    "
                    @click="form.currentpage = parseInt(data)"
                  >
                    {{
                      grid.paginaiton.pageNo == data ? "[" + data + "]" : data
                    }}
                  </span>
                  <input
                    type="button"
                    class="btn"
                    value=">>"
                    style="height: 28px"
                    v-show="grid.paginaiton.pageNo < grid.paginaiton.totalPage"
                    @click="form.currentpage = grid.paginaiton.pageNo + 1"
                  />
                  ［每頁<input
                    type="text"
                    v-model.number.lazy="form.pagesize"
                    size="2"
                    maxlength="4"
                  />

                  <input type="button" class="btn" value="筆" />，第<input
                    type="text"
                    v-model.number.lazy="form.currentpage"
                    size="2"
                    maxlength="4"
                  />
                  <input type="button" class="btn" value="頁" />，共
                  {{ grid.paginaiton.totalPage }} 頁
                  {{ grid.paginaiton.totalCount }} 筆］
                </td>
              </tr>
            </tbody>
          </table>
          <div class="active">
            <div class="table_scroll2">
              <table class="itable">
                <thead>
                  <tr>
                    <th colspan="2">操作</th>
                    <th style="min-width: 80px">帳號</th>
                    <th style="min-width: 80px">姓名</th>
                    <th style="width: 200px">備註</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(data, index) in grid.gridDatas"
                    :key="index"
                    style="text-align: center"
                  >
                    <td width="1%" align="center">
                      <input
                        type="button"
                        class="btn"
                        @click="btnEdit(data)"
                        value="編"
                      />
                    </td>
                    <td width="1%" align="center">
                      <input
                        type="button"
                        class="btn"
                        @click="btnDelete(data)"
                        value="刪"
                      />
                    </td>
                    <td>{{ data.id }}</td>
                    <td>{{ data.name }}</td>
                    <td>{{ data.note }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <!-- 查詢結果結束-->
      </div>
    </div>

    <CyFooter />

    <DetailModal
      v-model="DetailModal.show"
      :title="DetailModal.title"
      :ServiceUnit="pageData.ServiceUnit"
      :modalStyle="{ 'max-width': '1200px' }"
    >
      <div class="information">
        <div class="table_scroll2">
          <table class="newTable">
            <tbody>
              <tr>
                <td>帳號</td>
                <td colspan="3">
                  <input
                    type="text"
                    v-model="DetailModal.form.id"
                    :disabled="DetailModal.modifyType == 'U'"
                  />
                  <input
                    title="使用者忘記密碼，可使用本功能初始化密碼"
                    type="button"
                    class="btn"
                    value="密碼初始化"
                    @click="btnDetailPwSave()"
                  />
                  <!--<input title="使用者忘記密碼，可使用本功能初始化密碼"
                  onclick="alert('密碼初始化，將寄EMAIL通知使用者，是否確定執行?')"
                  value="" data-toggle="modal" data-target=".bs-example-modal-lg">-->
                </td>
              </tr>
              <tr>
                <td>姓名</td>
                <td>
                  <input type="text" v-model="DetailModal.form.name" />
                </td>
                <td>身分證統一編號</td>
                <td>
                  <input type="text" v-model="DetailModal.form.idn" />
                </td>
              </tr>
              <tr>
                <td>生日</td>
                <td colspan="3">
                  <DatePicker
                    v-model="DetailModal.form.birthday"
                    format="YYYYMMDD"
                    :isTaiwanYear="false"
                    clearable
                    placeholder="請輸入/選擇日期"
                  />
                </td>
              </tr>
              <tr>
                <td>職稱</td>
                <td>
                  <input type="text" v-model="DetailModal.form.title" />
                </td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>聯絡電話</td>
                <td>
                  <input type="text" v-model="DetailModal.form.tel" />
                </td>
                <td>E-Mail</td>
                <td>
                  <input
                    type="text"
                    v-model="DetailModal.form.email"
                    size="40"
                    maxlength="40"
                  />
                </td>
              </tr>
              <tr>
                <td>到職日</td>
                <td>
                  <DatePicker
                    v-model="DetailModal.form.arriveDate"
                    format="YYYYMMDD"
                    :isTaiwanYear="false"
                    clearable
                    placeholder="請輸入/選擇日期"
                  />
                </td>
                <td>在職狀態</td>
                <td>
                  <select v-model="DetailModal.form.now_st">
                    <option :value="1">在職</option>
                    <option :value="2">離職</option>
                  </select>
                </td>
              </tr>
              <tr>
                <td>角色群組</td>
                <td colspan="3">
                  <select
                    v-model="DetailModal.form.role_seq"
                    style="min-width: 480px"
                  >
                    <option
                      v-for="(item, index) in DetailModal.dropDownList
                        .onRoleSeqs"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                </td>
              </tr>
              <tr>
                <td>
                  帳號狀況
                  <input
                    title="帳號被鎖定可使用本功能解鎖"
                    type="button"
                    class="btn"
                    value="解鎖"
                    @click="btnDetailFlagSave()"
                    v-show="DetailModal.form.logiN_FLAG >= 3"
                  />
                </td>
                <td>
                  <input
                    type="radio"
                    name="RadioGroup1"
                    value="Y"
                    v-model="DetailModal.form.admin_flag"
                    checked="checked"
                  />啟用
                  <input
                    type="radio"
                    name="RadioGroup1"
                    value="N"
                    v-model="DetailModal.form.admin_flag"
                  />停用
                  <span v-if="DetailModal.form.logiN_FLAG >= 3">
                    <input
                      type="radio"
                      name="RadioGroup1"
                      disabled="disabled"
                      v-model="DetailModal.form.admin_flag"
                      value=""
                    />
                    鎖住(登入密碼錯誤達三次以上)
                  </span>
                  <span v-else style="margin-left: 10px">
                    登入密碼錯誤
                    {{
                      DetailModal.form.logiN_FLAG
                        ? DetailModal.form.logiN_FLAG
                        : 0
                    }}
                    次
                  </span>
                </td>
              </tr>
              <!--<tr>
                <td>應申報身分資格</td>
                <td colspan="3">
                  <select
                    v-model="DetailModal.form.status"
                    style="max-width: 1000px"
                  >
                    <option
                      v-for="(item, index) in DetailModal.dropDownList
                        .OnDeclare"
                      :value="item.mcode"
                      :key="index"
                    >
                      {{ item.mvalue }}
                    </option>
                  </select>
                </td>
              </tr>-->
              <tr>
                <td>備註</td>
                <td colspan="3">
                  <p>
                    <input
                      type="text"
                      v-model="DetailModal.form.note"
                      size="80"
                      maxlength="80"
                    />
                    <br />
                  </p>
                </td>
              </tr>
              <tr>
                <td colspan="6" class="f_center">
                  <label for="checkbox"
                    ><span>
                      <input
                        type="submit"
                        class="btn"
                        value="存檔"
                        @click="btnDetailSave()"
                      />
                      <input
                        type="submit"
                        class="btn"
                        value="重填"
                        @click="btnDetailClear()"
                      /> </span
                  ></label>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="f_center"></div>
      </div>
    </DetailModal>

    <Alert
      v-model="Alert.show"
      :title="Alert.title"
      :ServiceUnit="pageData.ServiceUnit"
    >
      <div style="text-align: center">
        <div
          v-for="(data, index) in Alert.txt"
          :key="index"
          style="margin-bottom: 10px"
        >
          <p>{{ data }}</p>
        </div>
        <div>
          <button class="btn" @click="Alert.BtnConfirm">確定</button>
        </div>
      </div>
    </Alert>
  </div>
</template>

<script>
import VueModal from "@/components/Common/vue-modal.vue";
import VueDatepicker from "@/components/Common/VueDatepickerLocal";
import Logo from "@/components/Common/Logo.vue";
import BackStageMenu from "@/components/BackStage/BackStageMenu.vue";
import CyFooter from "@/components/Common/CyFooter.vue";
import { getMenuIndex, ChkIdNo, logOut } from "@/config/util.js";
import {
  SearchCyGridOnRoleSeq,
  S315_SearchGrid,
  S315_Delete,
  S315_DetailAddSave,
  S315_DetailEditPwSave,
  S315_DetailEditFlagSave,
  S315_DetailEditSave,
} from "@/service/api.js";
export default {
  name: "S315",
  data: function () {
    return {
      pageData: {
        MenuIndex: 3,
        PrgName: "S315",
        ServiceUnit: "CY",
        isForceLoginOut: true,
      },
      loginInfo: JSON.parse(sessionStorage.getItem("LoginInfo"))
        ? JSON.parse(sessionStorage.getItem("LoginInfo"))
        : "",
      form: {
        id: "",
        idn: "",
        name: "",
        jobstatus: "",
        pagesize: 10,
        currentpage: 1,
      },
      dropDownList: {
        //角色群組
        onRoleSeqs: [],
      },
      grid: {},
      DetailModal: {
        show: false,
        title: "S315 帳號資料維護-編輯",
        form: {
          id: "",
          idn: "",
          name: "",
          birthday: "",
          title: "",
          //rank: "",
          tel: "",
          email: "",
          arriveDate: "",
          //角色群組
          role_seq: null,
          logiN_FLAG: null,
          //啟用狀態
          admin_flag: "",
          //備註
          note: "",
          now_st: "",
        },
        modifyType: "", //"I,U"
        dropDownList: {
          onRoleSeqs: [],
        },
        PreData: {},
      },
      Alert: {
        show: false,
        title: "",
        txt: "",
        BtnConfirm: function () {
          this.show = false;
        },
      },
    };
  },
  components: {
    Logo,
    BackStageMenu,
    CyFooter,
    Alert: VueModal,
    DetailModal: VueModal,
    DatePicker: VueDatepicker,
  },
  methods: {
    //取得角色群組 DetailModal
    modalGetOnRoleSeq: function () {
      const self = this;
      SearchCyGridOnRoleSeq({}).then((rData) => {
        self.DetailModal.dropDownList.onRoleSeqs = [
          { value: "", text: "" },
        ].concat(rData.returnObject);
      });
    },
    //取得角色群組
    getOnRoleSeq: function () {
      const self = this;
      SearchCyGridOnRoleSeq({}).then((rData) => {
        self.dropDownList.onRoleSeqs = [{ value: "", text: "" }].concat(
          rData.returnObject
        );
      });
    },
    //第一頁查詢
    doQuery: function () {
      const self = this;
      if (!self.checkPage(self.form.currentpage, self.form.pagesize)) return;
      let postData = {
        ID: self.form.id,
        IDN: self.form.idn,
        NAME: self.form.name,
        NOW_ST: self.form.jobstatus,
        CURRENTPAGE: self.form.currentpage,
        PAGESIZE: self.form.pagesize,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "查詢",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      S315_SearchGrid(postData).then((rData) => {
        if(rData.result){
          self.grid = rData.returnObject;
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = ["權限錯誤，請重新登入．"];
          self.Alert.BtnConfirm = () => {
            logOut(self.pageData.ServiceUnit,self);
          };
        }
      });
    },
    //分頁防呆檢查
    checkPage: function (currentpage, pagesize) {
      const self = this;
      let pageErrorMsg = [];
      if (currentpage) {
        if (isNaN(parseInt(currentpage))) {
          pageErrorMsg.push("頁數格式錯誤");
        }
      } else {
        pageErrorMsg.push("請填寫頁數");
      }
      if (pagesize) {
        if (isNaN(parseInt(pagesize))) {
          pageErrorMsg.push("筆數格式錯誤");
        }
      } else {
        pageErrorMsg.push("請填寫每頁筆數");
      }
      if (pageErrorMsg.length) {
        self.Alert.show = true;
        self.Alert.title = "錯誤";
        self.Alert.txt = pageErrorMsg;
        self.Alert.BtnConfirm = () => {
          self.Alert.show = false;
        };
        return false;
      }
      return true;
    },
    //第一頁重填
    doClear: function () {
      this.form = {
        id: "",
        idn: "",
        name: "",
        jobstatus: "",
      };
    },
    //第一頁新增
    btnAdd: function () {
      const self = this;
      self.DetailModal.PreData = {};
      self.DetailModal.form.id = "";
      self.DetailModal.form.idn = "";
      self.btnDetailClear();
      self.DetailModalInit1();
      self.DetailModal.modifyType = "I";
      self.DetailModal.title = "S315 帳號資料維護-新增";
      self.DetailModal.show = true;
    },
    //第一頁匯入
    btnImport: function () {
      const self = this;
      self.ImportModal.show = true;
    },
    //第一頁匯出
    btnExport: function () {
      const self = this;
      self.ExportModal.show = true;
      self.ExportModalBtnClear();
      self.ExportModal.dropDownList.syears =
        self.ExportModalGetSyearDropDownList();
      self.ExportModalGetSearchJobGovCode2(self.ExportModal.form.jobGovCode1);
      self.ExportModal.dropDownList.onRoleSeqs = self.ExportModalGetOnRoleSeq();
    },
    //gird
    //第一頁編
    btnEdit: function (data) {
      const self = this;
      self.DetailModal.PreData = data;
      self.DetailModalInit1();
      self.DetailModalInit2(data);
      self.DetailModal.modifyType = "U";
      self.DetailModal.title = "S315 帳號資料維護-編輯";
      self.DetailModal.show = true;
    },
    //第一頁刪
    btnDelete: function (data) {
      const self = this;
      S315_Delete({
        pkno: data.pkno,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "刪",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      }).then((rData) => {
        if (rData.result) {
          self.Alert.show = true;
          self.Alert.title = "訊息";
          self.Alert.txt = ["刪除成功"];
          self.Alert.BtnConfirm = () => {
            self.doQuery();
            self.Alert.show = false;
          };
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = ["刪除失敗"];
          self.Alert.BtnConfirm = () => (self.Alert.show = false);
        }
      });
    },
    //第一頁服務機關變動
    btnGovCodeEdit: function (data) {
      const self = this;
      //init
      self.govModalGetOnRoleSeq();
      self.govModalGetSearchJobGovCode2(self.GovCodeModal.form.jobGovCode1);
      self.govModalGetSearchNewJobGovCode1();
      self.govModalGetSearchNewJobGovCode2(
        self.GovCodeModal.form.newJobGovCode1
      );
      self.GovCodeModal.PreData = data;
      self.getGovModalData();
      self.GovCodeModal.show = true;
    },
    //第一頁服務機關變動紀錄
    btnSearchLog: function (idn) {
      const self = this;
      self.LogModal.form.idn = idn;
      let postData = {
        idn: idn,
        currentpage: 1,
        pagesize: 10,
      };
      S305_SearchLog(postData).then((rData) => {
        self.LogModal.grid = rData.returnObject;
        self.LogModal.show = true;
      });
    },
    DetailModalInit1: function () {
      const self = this;
      self.modalGetOnRoleSeq();
    },
    //第二頁明細init
    DetailModalInit2: function (data) {
      const self = this;
      self.DetailModal.form.id = data.id;
      self.DetailModal.form.idn = data.idn;
      self.DetailModal.form.name = data.name;
      //self.DetailModal.form.rank = data.rank;
      self.DetailModal.form.tel = data.tel;
      self.DetailModal.form.email = data.email;
      self.DetailModal.form.birthday = data.birthday
        ? self.$moment(data.birthday)._d
        : "";
      self.DetailModal.form.title = data.title;
      self.DetailModal.form.arriveDate = data.arrivE_DATE
        ? self.$moment(data.arrivE_DATE)._d
        : "";
      //角色群組
      self.DetailModal.form.role_seq = data.rolE_SEQ;
      self.DetailModal.form.logiN_FLAG = data.logiN_FLAG;
      //啟用狀態
      self.DetailModal.form.admin_flag = data.admiN_FLAG;
      //備註
      self.DetailModal.form.note = data.note;
      self.DetailModal.form.now_st = data.noW_ST;
      self.modalGetOnRoleSeq();
    },
    //第二頁明細新增 API
    S315_DetailAddSave: function () {
      const self = this;
      let postData = {
        PKNO: 0,
        ID: self.DetailModal.form.id,
        IDN: self.DetailModal.form.idn,
        NAME: self.DetailModal.form.name,
        //RANK: self.DetailModal.form.rank,
        TEL: self.DetailModal.form.tel,
        EMAIL: self.DetailModal.form.email,
        BIRTHDAY: self.DetailModal.form.birthday
          ? self.DetailModal.form.birthday
          : null,
        TITLE: self.DetailModal.form.title,
        USERID: self.loginInfo.id,
        ARRIVE_DATE: self.DetailModal.form.arriveDate
          ? self.DetailModal.form.arriveDate
          : null,
        //角色群組
        ROLE_SEQ: self.DetailModal.form.role_seq
          ? parseInt(self.DetailModal.form.role_seq)
          : null,
        //啟用狀態
        ADMIN_FLAG: self.DetailModal.form.admin_flag,
        //備註
        NOTE: self.DetailModal.form.note,
        NOW_ST: String(self.DetailModal.form.now_st),
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "第二頁明細新增",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      console.log(JSON.stringify(postData));
      S315_DetailAddSave(postData).then((rData) => {
        if (rData.result) {
          self.Alert.show = true;
          self.Alert.title = "訊息";
          self.Alert.txt = ["新增成功"];
          self.Alert.BtnConfirm = () => {
            self.Alert.show = false;
            self.DetailModal.show = false;
            self.doQuery();
          };
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = ["新增失敗"];
          self.Alert.BtnConfirm = () => (self.Alert.show = false);
        }
        //console.log(rData);
      });
    },
    //第二頁明細修改 API
    S315_DetailEditSave: function () {
      const self = this;
      let postData = {
        PKNO: self.DetailModal.PreData.pkno,
        ID: self.DetailModal.form.id,
        IDN: self.DetailModal.form.idn,
        NAME: self.DetailModal.form.name,
        //RANK: self.DetailModal.form.rank,
        TEL: self.DetailModal.form.tel,
        EMAIL: self.DetailModal.form.email,
        BIRTHDAY: self.DetailModal.form.birthday
          ? self.DetailModal.form.birthday
          : null,
        TITLE: self.DetailModal.form.title,
        USERID: self.loginInfo.id,
        ARRIVE_DATE: self.DetailModal.form.arriveDate
          ? self.DetailModal.form.arriveDate
          : null,
        //角色群組
        ROLE_SEQ: self.DetailModal.form.role_seq
          ? parseInt(self.DetailModal.form.role_seq)
          : null,
        //啟用狀態
        ADMIN_FLAG: self.DetailModal.form.admin_flag,
        //備註
        NOTE: self.DetailModal.form.note,
        NOW_ST: String(self.DetailModal.form.now_st),
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "第二頁明細修改",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      console.log(JSON.stringify(postData));
      S315_DetailEditSave(postData).then((rData) => {
        if (rData.result) {
          self.Alert.show = true;
          self.Alert.title = "訊息";
          self.Alert.txt = ["修改成功"];
          self.Alert.BtnConfirm = () => {
            self.Alert.show = false;
            self.DetailModal.show = false;
            self.doQuery();
          };
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = ["修改失敗"];
          self.Alert.BtnConfirm = () => (self.Alert.show = false);
        }
      });
    },
    //第二頁明細修改密碼 API
    S315_DetailEditPwSave: function () {
      const self = this;
      let postData = {
        PKNO: self.DetailModal.PreData.pkno,
        ID: self.DetailModal.form.id,
        IDN: self.DetailModal.form.idn,
        NAME: self.DetailModal.form.name,
        //RANK: self.DetailModal.form.rank,
        TEL: self.DetailModal.form.tel,
        EMAIL: self.DetailModal.form.email,
        BIRTHDAY: self.DetailModal.form.birthday
          ? self.DetailModal.form.birthday
          : null,
        TITLE: self.DetailModal.form.title,
        USERID: self.loginInfo.id,
        ARRIVE_DATE: self.DetailModal.form.arriveDate
          ? self.DetailModal.form.arriveDate
          : null,
        //角色群組
        ROLE_SEQ: self.DetailModal.form.role_seq
          ? parseInt(self.DetailModal.form.role_seq)
          : null,
        //啟用狀態
        ADMIN_FLAG: self.DetailModal.form.admin_flag,
        //備註
        NOTE: self.DetailModal.form.note,
        NOW_ST: String(self.DetailModal.form.now_st),
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "第二頁明細修改密碼",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      console.log(JSON.stringify(postData));
      S315_DetailEditPwSave(postData).then((rData) => {
        if (rData.result) {
          self.Alert.show = true;
          self.Alert.title = "訊息";
          self.Alert.txt = ["密碼初始化成功"];
          self.Alert.BtnConfirm = () => {
            self.Alert.show = false;
            self.DetailModal.show = false;
            self.doQuery();
          };
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = ["密碼初始化失敗"];
          self.Alert.BtnConfirm = () => (self.Alert.show = false);
        }
      });
    },
    //第二頁明細修改狀態 API
    S315_DetailEditFlagSave: function () {
      const self = this;
      let postData = {
        PKNO: self.DetailModal.PreData.pkno,
        ID: self.DetailModal.form.id,
        IDN: self.DetailModal.form.idn,
        NAME: self.DetailModal.form.name,
        //RANK: self.DetailModal.form.rank,
        TEL: self.DetailModal.form.tel,
        EMAIL: self.DetailModal.form.email,
        BIRTHDAY: self.DetailModal.form.birthday
          ? self.DetailModal.form.birthday
          : null,
        TITLE: self.DetailModal.form.title,
        USERID: self.loginInfo.id,
        ARRIVE_DATE: self.DetailModal.form.arriveDate
          ? self.DetailModal.form.arriveDate
          : null,
        //角色群組
        ROLE_SEQ: self.DetailModal.form.role_seq
          ? parseInt(self.DetailModal.form.role_seq)
          : null,
        //啟用狀態
        ADMIN_FLAG: self.DetailModal.form.admin_flag,
        //備註
        NOTE: self.DetailModal.form.note,
        NOW_ST: String(self.DetailModal.form.now_st),
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "第二頁明細修改狀態",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      console.log(JSON.stringify(postData));
      S315_DetailEditFlagSave(postData).then((rData) => {
        if (rData.result) {
          self.Alert.show = true;
          self.Alert.title = "訊息";
          self.Alert.txt = ["解鎖成功"];
          self.Alert.BtnConfirm = () => {
            self.Alert.show = false;
            self.DetailModal.show = false;
            self.doQuery();
          };
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = ["解鎖失敗"];
          self.Alert.BtnConfirm = () => (self.Alert.show = false);
        }
      });
    },
    CheckInputData: function () {
      const self = this;
      let msg = [];
      if (!self.DetailModal.form.id) {
        msg.push("請填寫帳號");
      }
      if (self.DetailModal.form.idn) {
        if (!ChkIdNo(self.DetailModal.form.idn)) {
          msg.push("身分證統一編號格式不對");
        }
      }
      if (msg.length) {
        self.Alert.show = true;
        self.Alert.title = "錯誤";
        self.Alert.txt = msg;
        self.Alert.BtnConfirm = () => (self.Alert.show = false);
        return false;
      }
      return true;
    },
    //第二頁按紐明細存檔
    btnDetailSave: function () {
      const self = this;
      if (!self.CheckInputData()) return;
      if (self.DetailModal.modifyType == "I") {
        self.S315_DetailAddSave();
      } else if (self.DetailModal.modifyType == "U") {
        self.S315_DetailEditSave();
      }
    },
    btnDetailPwSave: function () {
      const self = this;
      if (self.DetailModal.modifyType == "U") {
        self.S315_DetailEditPwSave();
      }
    },
    btnDetailFlagSave: function () {
      const self = this;
      if (self.DetailModal.modifyType == "U") {
        self.S315_DetailEditFlagSave();
      }
    },
    //第二頁明細重填
    btnDetailClear: function () {
      const self = this;
      self.DetailModal.form = {
        id: self.DetailModal.modifyType == "U" ? self.DetailModal.form.id : "",
        idn:
          self.DetailModal.modifyType == "U" ? self.DetailModal.form.idn : "",
        name: "",
        birthday: "",
        title: "",
        //rank: "",
        tel: "",
        email: "",
        arriveDate: "",
        //角色群組
        role_seq: null,
        logiN_FLAG: null,
        //啟用狀態
        admin_flag: "",
        //備註
        note: "",
        now_st: "",
      };
    },
    //第三頁 機關變動 API
    getGovModalData: function () {
      const self = this;
      S305_Detail({ pkno: self.GovCodeModal.PreData.pkno }).then((rData) => {
        if (rData.result) {
          self.GovCodeModal.grid = rData.returnObject;
          self.GovCodeModal.form = {
            govCode1: self.GovCodeModal.grid.govCodeStr.split(",")[0],
            govCode2: self.GovCodeModal.grid.govCodeStr.split(",")[1],
            govCode3: self.GovCodeModal.grid.govCodeStr.split(",")[2],
            govCode4: self.GovCodeModal.grid.govCodeStr.split(",")[3],
            idn: self.GovCodeModal.grid.idn,
            name: self.GovCodeModal.grid.name,
            arriveDate: self.GovCodeModal.grid.arriveDate,
            leaveDate: self.GovCodeModal.grid.leaveDate,
            //現職狀況
            leave: self.GovCodeModal.grid.leave,
            //備註
            leave_Reason: self.GovCodeModal.grid.leaveReason,
            newJobGovCode1: sessionStorage.getItem("Session_GovCode"),
            newJobGovCode2: "",
            newJobGovCode3: "",
            newJobGovCode4: "",
          };
        }
      });
    },
  },
  created() {
    const self = this;
    //RoleAuthorizeMenu
    self.pageData.MenuIndex = getMenuIndex(self.pageData.PrgName);
    if (self.pageData.MenuIndex === null) {
      self.Alert.show = true;
      self.Alert.title = "訊息";
      self.Alert.txt = ["無進入此頁權限，請洽詢管理員!!"];
      self.Alert.BtnConfirm = () => {
        self.Alert.show = false;
        self.$router.go(-1);
      };
    }
    self.doQuery();
    self.getOnRoleSeq();
  },
  watch: {
    "form.currentpage": function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.doQuery();
      }
    },
    "form.pagesize": function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.doQuery();
      }
    },
  },
};
</script>

<style scoped src="@/assets/css/Cy.css" />
